/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { AuthPostLogin } from './authentication-login.post';

export const GetAuthenticationOidcLoginCallback = {
  id: 'authentication.login-callback.get',
  tag: 'Authentication',
  summary: 'OIDC login callback',
  description: `Callback for logging in with an organization's OIDC provider`,
  method: 'get',
  route: () => `/authentication/oidc/login/callback`,
  response: { 200: AuthPostLogin.response['200'] },
} as const satisfies Endpoint;
